// button.ts — BUTTON_CSS: die EINE token-basierte Button-Quelle (PFS-682/683).
//
// Bis hierher hat jedes self-contained WC (login-form, mfa-*, overlay-host,
// row-actions, banner-host, paginator, scope-toggle) seinen eigenen `.btn`
// nachgebaut → 9 driftende Kopien (Padding 0.5/0.55/0.6rem, Weight 500/600).
// Diese Konstante ist die einzige Quelle; die Composites inlinen sie in ihre
// eigene Shadow (Muster wie SHADOW_RESET_CSS) — self-contained, drift-immun.
//
// Wertgetreu gespiegelt zur @pfs/design-Foundation `.btn` (foundation.ts) —
// „Duplikat muss identisch sein": ändert die Foundation eine Variante, hier
// nachziehen. pfs-components hängt bewusst NICHT an @pfs/design (immun gegen
// WP/Tailwind/Foundation-Bleed), spiegelt aber die Werte + Fallbacks aus
// src/css/tokens.css. KEIN `.ghost` — das ist Foundation-`.secondary`.
export const BUTTON_CSS = `
.btn {
  font: inherit;
  font-weight: 600;
  font-size: var(--pfs-font-size-base, 0.875rem);
  padding: 0.5rem 1rem;
  border-radius: var(--pfs-radius-sm, 0.375rem);
  border: 1px solid transparent;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.btn:focus-visible {
  outline: none;
  box-shadow: var(--pfs-shadow-focus-ring-strong, 0 0 0 3px rgba(59, 130, 246, 0.45));
}
.btn.sm { padding: 0.2rem 0.6rem; font-size: 0.8rem; line-height: 1.3; }
.btn.primary {
  background: var(--pfs-color-primary);
  border-color: var(--pfs-color-primary);
  color: var(--pfs-color-on-primary);
}
.btn.primary:hover { background: var(--pfs-color-primary-hover); }
.btn.secondary {
  background: var(--pfs-color-surface);
  border-color: var(--pfs-color-outline-strong);
  color: var(--pfs-color-on-surface-muted);
}
.btn.secondary:hover { background: var(--pfs-color-surface-hover); }
.btn.danger {
  background: var(--pfs-color-danger);
  border-color: var(--pfs-color-danger);
  color: var(--pfs-color-on-primary);
}
.btn.danger:hover { background: var(--pfs-color-danger-hover); }
.btn.success {
  background: var(--pfs-color-success);
  border-color: var(--pfs-color-success);
  color: var(--pfs-color-on-primary);
}
.btn.success:hover { background: var(--pfs-color-success-hover); }
.btn[disabled] { opacity: 0.6; cursor: not-allowed; }
.btn.block { width: 100%; display: block; }
`;
